import { AntdIconProps } from "@ant-design/icons/lib/components/AntdIcon";
import "./icon.less";
const Icon = ({ type, className, ...props }: AntdIconProps) => {
  const icons = require(`@ant-design/icons`);
  const Component = icons[type as string];
  return <Component {...props} className={`icon-Ant-design ${className}`} />;
};

export default Icon;
